import { CreateAwardData, CreateQuestionRequest } from "../entry/server/game.ts";
import { gameService } from "../services/game-service.ts";

export const gameRepo = {
    getQuestions: async (page: number, search?: string) => {
        return await gameService.getQuestions(page, search);
    },
    getQuestion: async (id: number) => {
        return await gameService.getQuestion(id);
    },
    createQuestion: async (question: CreateQuestionRequest) => {
        return await gameService.createQuestion(question);
    },
    updateQuestion: async (id: number, question: CreateQuestionRequest) => {
        return await gameService.updateQuestion(id, question);
    },
    deleteQuestion: async (id: number) => {
        return await gameService.deleteQuestion(id);
    },
    getAwards: async (page: number) => {
        return await gameService.getAwards(page);
    },
    getAward: async (id: number) => {
        return await gameService.getAward(id);
    },
    createAward: async (award: CreateAwardData) => {
        return await gameService.createAward(award);
    },
    updateAward: async (id: number, award: CreateAwardData) => {
        return await gameService.updateAward(id, award);
    },
    deleteAward: async (id: number) => {
        return await gameService.deleteAward(id);
    },
}